import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { STAT_SCOPE_OPTIONS } from '../constants/statScopes';
import { useJurisdictionsCatalog } from '../lib/jurisdictionsCatalog';

/**
 * Country / stats scope toggle for the game map and list views.
 * @param {{ currentMapType: string, variant?: 'full' | 'flag' }} props
 */
const CountryToggler = ({ currentMapType, variant = 'full' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { scopeOptions, loaded } = useJurisdictionsCatalog();
  const options = loaded && scopeOptions?.length ? scopeOptions : STAT_SCOPE_OPTIONS;

  const currentCountry =
    options.find((country) => country.code === currentMapType) || options[0];

  const handleCountryChange = (countryCode) => {
    const params = new URLSearchParams(location.search);
    params.set('map', countryCode);
    navigate(`/?${params.toString()}`, { replace: true });
    setIsOpen(false);
  };

  if (variant === 'flag') {
    return (
      <div className="flag-only-dropdown">
        <button
          className="flag-only-button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label={`Select country, currently ${currentCountry.name}`}
          title={currentCountry.name}
        >
          <span className="flag-emoji">{currentCountry.flag}</span>
          <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
        </button>
        {isOpen && (
          <div className="flag-dropdown">
            {options.map((country) => (
              <button
                key={country.code}
                className={`flag-option ${country.code === currentMapType ? 'active' : ''}`}
                onClick={() => handleCountryChange(country.code)}
                title={country.name}
              >
                <span className="flag-emoji">{country.flag}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="country-toggler">
      <button
        className="country-toggler-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select country"
      >
        <span className="country-flag">{currentCountry.flag}</span>
        <span className="country-name">{currentCountry.name}</span>
        <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className="country-dropdown">
          {options.map((country) => (
            <button
              key={country.code}
              className={`country-option ${country.code === currentMapType ? 'active' : ''}`}
              onClick={() => handleCountryChange(country.code)}
            >
              <span className="country-flag">{country.flag}</span>
              <span className="country-name">{country.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountryToggler;
